export enum LOCAL_STORAGE_CODES {
	MOST_RECENT_OPEN_EDGE_READER_LOCAL_STORAGE_KEY = 'pms-most-recent-open-edge-reader',
}
